import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { C43MediaGalleryItemFields } from '../C43MediaGalleryItem/C43MediaGalleryItem.types';
import {
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
  ImagePropertiesParams,
  RenderingProps,
} from 'src/shared/shared.types';

export type C43MediaGalleryProps = RenderingProps<
  C43MediaGalleryFields,
  C43MediaGalleryParams,
  C43MediaGalleryPlaceholder
>;

export type C43MediaGalleryFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
};

export type C43MediaGalleryParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  BackgroundColor?: string;
  HideThumbnails?: string;
  HideNavigation?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams &
  ImagePropertiesParams;

export type C43MediaGalleryPlaceholder = {
  'media-gallery-container-{*}'?: {
    componentName?: string;
    fields?: C43MediaGalleryItemFields;
  }[];
};
